// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CallLogWithDurationPagingResultModel from '../../model/call-log-with-duration-paging-result-model';
import CallLogWithDurationPagingResultDTO from '../dto/call-log-with-duration-paging-result-dto';
import dtoSchema from '../schemas/call-log-with-duration-paging-result-schema';
import CallLogWithDurationModel from '../../model/call-log-with-duration-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class CallLogWithDurationPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CallLogWithDurationPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => CallLogWithDurationModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: CallLogWithDurationModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<CallLogWithDurationPagingResultDTO>): CallLogWithDurationPagingResultModel;
  static toModel(dto: DeepPartial<CallLogWithDurationPagingResultDTO> | undefined | null): CallLogWithDurationPagingResultModel | undefined;
  static toModel(dto: DeepPartial<CallLogWithDurationPagingResultDTO> | undefined | null): CallLogWithDurationPagingResultModel | undefined {
    return dto ? new CallLogWithDurationPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CallLogWithDurationPagingResultModel> | CallLogWithDurationPagingResultModel): CallLogWithDurationPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as CallLogWithDurationPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for CallLogWithDurationPagingResultModel, can not map to CallLogWithDurationPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
